var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemUiconsWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3105 17.6402H18.3105M16.3105 6.64016L17.3105 7.64016M17.8105 4.14016C18.0076 4.33712 18.1639 4.57097 18.2705 4.82834C18.3771 5.08571 18.432 5.36157 18.432 5.64016C18.432 5.91875 18.3771 6.19461 18.2705 6.45198C18.1639 6.70935 18.0076 6.9432 17.8105 7.14016L8.31055 16.6402L4.31055 17.6402L5.31055 13.6962L14.8145 4.14416C15.1891 3.76773 15.6916 3.54592 16.2222 3.52277C16.7527 3.49961 17.2726 3.6768 17.6785 4.01916L17.8105 4.14016Z",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsWrite);
export default __webpack_public_path__ + "static/media/system-uicons_write.a51401feb34140ad10473b54bc1c5599.svg";
export { ForwardRef as ReactComponent };